import { BASE_API_URL } from './index';

// eslint-disable-next-line import/prefer-default-export
export const currentUserEndpoint = `${BASE_API_URL}/user/me/`;

// eslint-disable-next-line import/prefer-default-export
export const pingLogoutEndpoint = `${BASE_API_URL}/user/ping/`;
